import React from "react";

const VectorBeachMat = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg
            width="240"
            height="120"
            viewBox="0 0 240 120"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            {/* Perspective Shadow */}
            <path d="M40 90 L200 90 L230 40 L70 40 Z" fill="#3D2B1F" opacity="0.1" />

            {/* Mat with 1-point perspective feel */}
            <g transform="translate(10, 10)">
                {/* Main White Base */}
                <path d="M30 80 L190 80 L210 30 L50 30 Z" fill="#FFFFFF" stroke="#E0E0E0" strokeWidth="0.5" />

                {/* Light Blue Stripes - User preferred color #22c4ecff */}
                <g fill="#96760dff">
                    <path d="M35 72 L185 72 L189 62 L39 62 Z" />
                    <path d="M43 52 L193 52 L197 42 L47 42 Z" />
                    {/* Top edge stripe */}
                    <path d="M48 35 L198 35 L202 32 L52 32 Z" opacity="0.6" />
                </g>

                {/* Subtle cloth texture/lines */}
                <g stroke="#000" strokeWidth="0.2" opacity="0.05">
                    <line x1="60" y1="30" x2="45" y2="80" />
                    <line x1="90" y1="30" x2="80" y2="80" />
                    <line x1="120" y1="30" x2="115" y2="80" />
                    <line x1="150" y1="30" x2="150" y2="80" />
                    <line x1="180" y1="30" x2="185" y2="80" />
                </g>

                {/* Fringe detail at the edges */}
                <g stroke="#E0E0E0" strokeWidth="1" strokeLinecap="round">
                    <line x1="30" y1="80" x2="28" y2="84" />
                    <line x1="62" y1="80" x2="60" y2="84" />
                    <line x1="94" y1="80" x2="92" y2="84" />
                    <line x1="126" y1="80" x2="124" y2="84" />
                    <line x1="158" y1="80" x2="156" y2="84" />
                    <line x1="190" y1="80" x2="188" y2="84" />
                </g>
            </g>
        </svg>
    );
};

export default VectorBeachMat;
